// Upgrade an existing session once, without persisting any new bearer tokens.
let migration;

// A login must not race an older exchange that would overwrite its new cookie.
export const finishLegacyMigration = async () => {
  if (migration) await migration.catch(() => {});
};

export const migrateLegacySession = async (exchange) => {
  const token = localStorage.getItem('token');
  if (!token) return;
  if (!migration) {
    migration = exchange(token)
      .then(() => localStorage.removeItem('token'))
      .catch((error) => {
        if ([401, 403].includes(error.response?.status)) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
        throw error;
      })
      .finally(() => { migration = undefined; });
  }
  await migration;
};
